<template>
  <form id="frm_action">
    <div class="p-formgrid row">
      <div class="col-lg-6">
        <div class="">
          <label class="txt-right required">Vai trò</label>
          <Dropdown  v-model="usersRole" :options="listUsersRole" optionLabel="name" placeholder="Chọn vai trò"/>
          <input class="input_tmp_validator" id="usersRole" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Tên người dùng</label>
          <InputText
            v-model="fullname"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            id="fullname"
            :disabled="mode=='edit'"
          />
        </div>

        <!-- <div class="mt-3">
          <label class="txt-right required">Username</label>
          <InputText
            v-model="username"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            :disabled="mode=='edit'"
            id = "username"
          />
        </div> -->

        <div class="mt-3">
          <label class="txt-right required">Email</label>
          <InputText
            v-model="email"
            type="text"
            class="text-box input-text-box"
            placeholder="email@gmail.com"
            id = "email"
          />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Số điện thoại</label>
          <InputText
            v-model="phone"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            @input="phone = phone.replace(/[^0-9]/g, '')"
            id="phone"
            :disabled="mode=='edit'"
          />
        </div>

        <div class="mt-3">
          <label class="txt-right" :class="{ required: mode == 'add' }">Mật khẩu đăng nhập</label>
          <CPassword v-model="password" type="password" class="cs-input input-text-box" :toggleMask="true" showIcon="pi pi-eye-slash" hideIcon="pi pi-eye"/>
          <input class="input-group input_tmp_validator" id="password" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Công ty</label>
            <Dropdown :disabled="mode=='edit'" v-model="company" :options="listCompany" optionLabel="name" placeholder="Tên công ty"/>
            <input class="input_tmp_validator" id="company" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Trang trại</label>
            <Dropdown :disabled="mode=='edit'" v-model="farm" :options="listFarm" optionLabel="name" placeholder="Tên trang trại"/>
            <input class="input_tmp_validator" id="farm" />
        </div>

        <div class="mt-3 d-flex align-items-center p-0">
          <Checkbox id="active" v-model="active" :binary="true" />
          <label for="active" class="m-0 ml-2">Hiển thị</label>
        </div>

      </div>

      <Toolbar class="fixed-bottom-toolbar col-lg-12">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
//import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import Password from "@/components/Password";

export default {
  components: {
    CPassword: Password
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      usersRole: null,
      listUsersRole: [],
      fullname: '',
      // username: '',
      email : '',
      phone: '',
      password: '',
      company: null,
      listCompany: [],
      farm: null,
      listFarm: [],
      active: true,
    }
  },
  async mounted() {
    await this.getListCompany();
    await this.getListUsersRole();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.$commonFuction.is_loading(true);
      try {
        this.usersRole = this.model.users_role;
        this.fullname = this.model.fullname;
        // this.username = this.model.username;
        this.email = this.model.email;
        this.phone = this.model.phone;
        if (this.model.company_id) {
          this.company = this.listCompany.find(x => x.id == this.model.company_id);
        }
        if (this.model.farm_id) {
          await this.getListFarm();
          this.farm = this.listFarm.find(x => x.id == this.model.farm_id);
        }
        this.active = this.model.active;
        this.$commonFuction.is_loading(false);
      } catch(err) {
        console.log("Errrr", err);
        this.$commonFuction.is_loading(false);
      }
    }
  },
  watch: {
    async company() {
      await this.getListFarm();
    },
  },
  methods: {

    backToList() {
      this.$emit('back');
    },

    async getListCompany() {
      var gqLQueryList = DataServices.getList("company", {"fields": "id, name"});
      var where = {
          active: {_eq: true},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { name: "asc" },
        },
      });
      var listData = resData.data["company"];
      this.listCompany = listData;
    },

    async getListFarm() {
      var gqLQueryList = DataServices.getList("farm", {"fields": "id, name"});
      var where = {
          active: {_eq: true},
          company_id: {_eq: this.company.id}
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { name: "asc" },
        },
      });
      var listData = resData.data["farm"];
      this.listFarm = listData;
    },

    async getListUsersRole() {
      var gqLQueryList = DataServices.getList("users_role", {"fields": "id, role, name"});
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          orderBy: { role: "asc" },
        },
      });
      var listData = resData.data["users_role"];
      this.listUsersRole = listData;
    },

    async validateData() {
      this.validationErrors = {};

      await this.$nextTick(); // Ensure DOM is fully rendered

      let role_add = document.getElementById("usersRole");
      if (this.usersRole == null || this.usersRole == undefined) {
        role_add.setCustomValidity("Vui lòng chọn vai trò");
      } else {
        role_add.setCustomValidity("");
      }

      let fullname_add = document.getElementById("fullname");
      if (!this.fullname) {
        fullname_add.setCustomValidity("Vui lòng nhập tên người dùng");
      } else if (this.fullname.length > 255) {
        fullname_add.setCustomValidity("Tên người dùng không được quá 255 ký tự");
      } else {
        fullname_add.setCustomValidity("");
      }

      // let username_add = document.getElementById("username");
      // if (
      //   this.username == undefined ||
      //   this.username == null ||
      //   this.username == ""
      // ) {
      //   username_add.setCustomValidity("Tên đăng nhập không được để trống!");
      // } else if (this.username.length > 50) {
      //   username_add.setCustomValidity("Tên đăng nhập không được quá 50 ký tự!");
      // } else if (await this.existUsername()) {
      //   username_add.setCustomValidity(`Tên đăng nhập ${this.username} đã tồn tại!`);
      // } else {
      //   username_add.setCustomValidity("");
      // }

      let email_add = document.getElementById("email");
      if (!this.email) {
        email_add.setCustomValidity("Vui lòng nhập email");
      } else if (!this.validateEmail()) {
        email_add.setCustomValidity("Email không hợp lệ");
      } else if (await this.existEmail()) {
        email_add.setCustomValidity(`Email ${this.email} đã tồn tại!`);
      } else {
        email_add.setCustomValidity("");
      }

      let phone_add = document.getElementById("phone");
      if (
        this.phone == undefined ||
        this.phone == null ||
        this.phone == ""
      ) {
        phone_add.setCustomValidity("Số điện thoại không được để trống!");
      } else {
        if (isNaN(this.phone)) {
          phone_add.setCustomValidity("Số điện thoại không đúng định dạng!");
        } else if (this.phone.length > 10 || this.phone.length < 9) {
          phone_add.setCustomValidity("Số điện thoại chỉ được 10 ký tự!");
        } else if (await this.existPhone()) {
          phone_add.setCustomValidity(`Số điện thoại ${this.phone} đã tồn tại!`);
        } else {
          phone_add.setCustomValidity("");
        }
      }

      let password_add = document.getElementById("password");
      if (this.mode == "add") {
        if (
          this.password == undefined ||
          this.password == null ||
          this.password == ""
        ) {
          password_add.setCustomValidity("Mật khẩu không được để trống!");
        } 
        // else {
        //   password_add.setCustomValidity(
        //     (await this.validatePassword()).toString()
        //   );
        // }
      } else {
        password_add.setCustomValidity("");
      }

      let company_add = document.getElementById("company");
      if (this.company == undefined || this.company == null) {
        company_add.setCustomValidity("Vui lòng chọn công ty");
      } else {
        company_add.setCustomValidity("");
      }

      let farm_add = document.getElementById("farm");
      if (this.farm == undefined || this.farm == null) {
        farm_add.setCustomValidity("Vui lòng chọn trang trại");
      } else {
        farm_add.setCustomValidity("");
      }


      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async validatePassword() {
      if (this.password.length < 8) {
        return "Mật khẩu phải có ít nhất 8 ký tự!";
      }
      if (this.password.length > 50) {
        return "Mật khẩu không được quá 50 ký tự!";
      }
      if (!/[A-Z]/.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      if (!/[a-z]/.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      if (!/[0-9]/.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      var re = /^(?=.*\d)(?=.*[!@#$%^&*])/;
      if (!re.test(this.password)) {
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-=";
      }
      if (!((/[A-Z]/.test(this.password)) || (/[0-9]/.test(this.password)) || (re.test(this.password)) || (/[a-z]/.test(this.password))))
        return "Vui lòng nhập mật khẩu có 1 ký tự hoa + thường, 1 ký tự số, 1 ký tự đặc biệt ~!@#$%^&*()_+-="
      return "";
    },

    async existUsername() {
      var gqLQueryList = DataServices.getList("users", {"fields": "id"});
      var where = {
          username: {_eq: this.username},
          id: {_neq: this.model.id},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
        },
      });
      if (resData.data.users.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    async existEmail() {
      var gqLQueryList = DataServices.getList("users", {"fields": "id"});
      var where = {
          email: {_eq: this.email},
          id: {_neq: this.model.id},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
        },
      });
      if (resData.data.users.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    async existPhone() {
      var gqLQueryUsers = DataServices.getList("users", {"fields": "id"});
      var whereUsers = {
        phone: {_eq: this.phone},
        id: {_neq: this.model.id},
      };
      
      var gqLQueryAccounts = DataServices.getList("accounts", {"fields": "id, uid"});
      var whereAccounts = {
        account: {_eq: this.phone},
        uid: {_neq: this.model.id},
      };

      const [usersResult, accountsResult] = await Promise.all([
        this.$apollo.mutate({
          mutation: gqLQueryUsers,
          variables: {
            where_key: whereUsers,
          },
        }),
        this.$apollo.mutate({
          mutation: gqLQueryAccounts,
          variables: {
            where_key: whereAccounts,
          },
        })
      ]);

      const usersExist = usersResult.data.users.length > 0;
      const accountsExist = accountsResult.data.accounts.length > 0;

      return usersExist || accountsExist;
    },

    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email);
    },
    
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }

      if (Object.entries(this.validationErrors).length > 0) {
        this.$commonFuction.is_loading(false);
        return;
      }

      let user_id = this.$store.getters.user;
      //console.log("user_id", user_id);

      var params = {
        users_role: this.usersRole,
        fullname: this.fullname,
        username: this.username,
        email: this.email,
        phone: this.phone,
        password: this.password ? this.password : null,
        company_id: this.company.id,
        company_name: this.company.name,
        farm_id: this.farm.id,
        farm_name: this.farm.name,
        active: this.active,
        created_by: user_id,
      };

      // console.log("saveData", params);
      this.$emit('save', params);
      //this.$commonFuction.is_loading(false);
    },
  },

}
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 480px;
  height: 270px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-multiselect-panel .p-checkbox.p-component {
  display: none !important;
}
</style>

